import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["appearance", "as"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { ListMixin } from '../../mixins/components/ListMixin';
import { ListItem } from '../ListItem/ListItem';

/**
 * A simple container component for vertical groupings of related content.
 * See `Table` for complex content or various font sizing and spacing requirements.
 *
 * @subcomponents [`List.Item`]
 * @since 8.14.0
 */
var List = /*#__PURE__*/styled( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var appearance = _ref.appearance,
    as = _ref.as,
    rest = _objectWithoutProperties(_ref, _excluded);
  var Component =
  // eslint-disable-next-line no-nested-ternary
  typeof as !== 'undefined' ? as : appearance === 'number' ? 'ol' : 'ul';
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref
  }, rest));
})).withConfig({
  displayName: "List",
  componentId: "c11n-8-111-1__sc-1smrmqp-0"
})(["", ""], ListMixin);
List.displayName = 'List';
List.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The type of list to display.
   */
  appearance: PropTypes.oneOf(['bullet', 'number', 'horizontalTable', 'none']),
  /**
   * The styled-components
   * [polymorphic "as"](https://styled-components.com/docs/api#as-polymorphic-prop) prop.
   *
   * By default, this is determined by prop `appearance`, a `<ol>` element with `number`
   * and `<ul>` element with the rest prop values. But we allow special cases.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: PropTypes.any
} : {};
List.defaultProps = {
  appearance: 'bullet'
};
List.Item = ListItem;

/** @component */
export { List };